import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Logo } from '@hub/logos';
import { RESPONSIBLE_BUSINESS, RESPONSIBLE_BUSINESS_REPORT, SCENTRE_GROUP_HOME } from '../paths';
import { AcknowledgementSection } from './acknowledgement-section';
import { Box } from '@hub/box';
import { Text } from '@hub/text';
import { Link } from '@hub/link';
import { ListItem, UnorderedList } from '@hub/list';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SiteFooter = _ref => {
  let {
    children,
    links = [],
    country,
    centreSlug = undefined
  } = _ref;
  return /*#__PURE__*/_jsxs(Box, {
    as: 'footer',
    sx: {
      backgroundColor: 'surfaceBrandPrimary',
      color: 'textPrimary',
      fontSize: ['font-body']
    },
    role: "contentinfo",
    "data-id": "site-footer_index_SiteFooter_Box",
    children: [/*#__PURE__*/_jsxs(Box, {
      sx: {
        marginX: 'auto',
        maxWidth: 'size-max-fixed',
        paddingX: ['spacing-lg', null, null, 'spacing-3xl'],
        paddingTop: ['spacing-xl'],
        paddingBottom: ['spacing-lg', null, null, 'spacing-xl']
      },
      "data-id": "site-footer_index_SiteFooter_Box_Box_1",
      children: [/*#__PURE__*/_jsx(Logo, {
        boxSize: "size-icon-line-height-base",
        sx: {
          maxHeight: 'size-6',
          verticalAlign: 'top'
        },
        variant: "westfield-red",
        "data-id": "site-footer_index_SiteFooter_Box_Logo"
      }), children && /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: ['column', null, 'row'],
          justifyContent: 'space-between',
          paddingY: ['spacing-lg', null, 'spacing-xl', 'spacing-xl']
        },
        "data-id": "site-footer_index_SiteFooter_Box",
        children: children
      }), /*#__PURE__*/_jsxs(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          borderTop: children ? '1px solid' : 'none',
          borderTopColor: 'quartz',
          paddingTop: 'spacing-lg'
        },
        "data-id": "site-footer_index_SiteFooter_Box_Box_4",
        children: [country && /*#__PURE__*/_jsx(_Fragment, {
          children: /*#__PURE__*/_jsx(AcknowledgementSection, {
            country: country,
            centreSlug: centreSlug,
            "data-id": "site-footer_index_SiteFooter_AcknowledgementSection"
          })
        }), /*#__PURE__*/_jsxs(Text, {
          sx: {
            marginTop: 'spacing-lg',
            '& a': {
              textDecoration: 'underline'
            }
          },
          "data-id": "site-footer_index_SiteFooter_Box_Text",
          children: ["Scentre Group operates its Westfield Living Centre portfolio with a", ' ', /*#__PURE__*/_jsx("a", {
            href: RESPONSIBLE_BUSINESS,
            "data-id": "site-footer_index_SiteFooter_Text_a",
            children: "responsible business"
          }), " mindset across the four pillars of community, people, environment and economic performance. More information can be found in our", ' ', /*#__PURE__*/_jsx("a", {
            href: RESPONSIBLE_BUSINESS_REPORT,
            "data-id": "site-footer_index_SiteFooter_Text_a_8",
            children: "2023 Responsible Business Report"
          }), "."]
        }), /*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            flexDirection: ['column', null, null, 'row'],
            marginTop: [null, null, null, 'spacing-lg']
          },
          "data-id": "site-footer_index_SiteFooter_Box_Box",
          children: [links && /*#__PURE__*/_jsx(UnorderedList, {
            sx: {
              listStyle: 'none',
              display: 'flex',
              flexWrap: 'wrap',
              flexDirection: ['column', null, null, 'row'],
              marginLeft: 0,
              marginTop: ['spacing-lg', null, null, 0],
              lineHeight: 'base',
              fontWeight: 'normal'
            },
            "data-id": "site-footer_index_SiteFooter_UnorderedList",
            children: links.map((_ref2, index) => {
              let {
                label,
                href
              } = _ref2;
              return /*#__PURE__*/_jsx(ListItem, {
                sx: _objectSpread({
                  marginRight: 'spacing-md'
                }, index > 0 && {
                  marginTop: ['spacing-md', null, 0]
                }),
                "data-id": "site-footer_index_SiteFooter_ListItem",
                children: /*#__PURE__*/_jsx("a", {
                  href: href,
                  "data-id": "site-footer_index_SiteFooter_ListItem_a",
                  children: label
                })
              }, href);
            })
          }), /*#__PURE__*/_jsxs(Text, {
            sx: {
              order: [1, null, null, 2],
              marginTop: ['spacing-lg', null, null, 0]
            },
            lineHeight: 'base',
            "data-id": "site-footer_index_SiteFooter_Box_Text",
            children: ["\xA9 All rights reserved", ' ', /*#__PURE__*/_jsx(Link, {
              isExternal: true,
              hasUnderline: true,
              href: SCENTRE_GROUP_HOME,
              "data-id": "site-footer_index_SiteFooter_Text_Link",
              children: "Scentre Group"
            }), ' ', new Date().getFullYear()]
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      sx: {
        backgroundColor: 'shapeBrandPrimary',
        height: 'size-xs'
      },
      "data-id": "site-footer_index_SiteFooter_Box_Box"
    })]
  });
};